module.exports = __webpack_public_path__ + "images/4161c982.png";